import FieldEditor from "editor/FieldEditor";
import VideoHelper from "video/VideoHelper";
import debounce from "debounce";

class FieldEditorVideo extends FieldEditor {
    create() {
        this.updatePreview = debounce(this.updatePreview, 200);

        this.$element.html(
            eotwJSXFactory('div', null, [
                eotwJSXFactory('div', {class: "admin-form__row"}, [
                    eotwJSXFactory('input', {class: "admin-form__input js-link", id: "video-url", name: "link", 'data-type': "url", 'data-name': "video url"}),
                    eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                ]),

                eotwJSXFactory('div', {class: "admin-form__row admin-gallery__row js-video-details", style: "display:none"}, [
                    eotwJSXFactory('div', {class: "admin-gallery__video"}, [
                        eotwJSXFactory('img', {class: "js-thumbnail"})
                    ]),
                    eotwJSXFactory('div', {class: "admin-gallery__info"}, [
                        eotwJSXFactory('span', {class: "admin-gallery__title js-title"}),
                        eotwJSXFactory('span', {class: "admin-gallery__duration js-provider"})
                    ])
                ])
            ])
        );

        this.$element.on("change keypress paste", ".js-link", () => this.updatePreview());
    }

    valid() {
        return this.$element.data("Validator").validate();
    }

    destroy() {
        super.destroy();

        this.$element.html("");
    }

    getValue() {
        let url = this.$element.find(".js-link").val();

        if (url === '') return null;
        return {url: url};
    }

    setValue(value) {
        if (value === null) {
            this.$element.find(".js-link").val('')
        } else if ('string' === typeof value) {
            this.$element.find(".js-link").val(value);
        } else {
            this.$element.find(".js-link").val(value.url ? value.url : (value.customData ? value.customData.url : ''));
        }
        this.updatePreview();
    }

    updatePreview() {
        let value = this.$element.find(".js-link").val();

        if (value === this.lastCheckedValue) return;
        this.lastCheckedValue = value;

        if (this.updatePreviewAjax) this.updatePreviewAjax.abort();

        if (value === '') {
            this.$element.find(".js-video-details").hide();
        } else {
            VideoHelper.get_video_details(value).then((data) => {
                if (value !== this.lastCheckedValue) return;

                this.$element.find(".js-title").text(data.name);
                this.$element.find(".js-thumbnail").attr("src", data.image);
                this.$element.find(".js-duration").text(data.duration);
                this.$element.find(".js-provider").text(data.provider);
                this.$element.find(".js-video-details").show();
            }).catch((message) => {
                if (value !== this.lastCheckedValue) return;

                this.$element.find(".js-link").data("Validator").showMessage(message);
                this.$element.find(".js-video-details").hide();
            });
        }
    }
}

FieldEditor.register_editor('video', FieldEditorVideo);

export default FieldEditor;
